export default {
  apiBaseURL: "https://api.tangeebl.com",
  // apiBaseURL: "http://192.168.2.146:3000",
  remote: "https://flatlogic-node-backend.herokuapp.com",
  isBackend: process.env.REACT_APP_BACKEND,
  language: 'en',
  defaultAuthToken: 'rlsTpo@s1n08ONbGikdkrvEgunxE1ojk0bzBy9tskepLrkv',
  defaultRefreshToken: 'LOVEjmLOV6G9Earypa9y5OhG3NpwLIanNEwbgaatfu3d',
  key: 'hjfnoisdskwofksdalfjdqapfhtyabnvkghtofgjdhkjayghgahfhbuntydjsdflafdhflaflhpifnxoamc',
  emailRegex: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,18})/,
  defaultRowsPerPage: [10, 25],
  subscriptionRole: [{ id: 3, role: "Investor" }, { id: 5, role: "Partnership" }],
  timePeriod_referral: [30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360],
  contentType: 'application/json',
  auth: {
    email: "admin@flatlogic.com",
    password: "password"
  },
  subscriptionList : [
    { id: 1, role: "Basic" },
    { id: 2, role: "Basic Plus" },
    { id: 3, role: "Investor" },
    // { id: 4, role: "Investor Plus" },
    { id: 5, role: "Partnership" },
    // { id: 6, role: "Partnership Plus" },
    { id: 7, role: "Enterprise" },
    { id: 10, role: "All" },
  ]
};
